import React from 'react';

export const AssignmentCardSkeleton = () => {
    return (
        <div className="bg-white border-2 border-gray-200 rounded-lg p-3 shadow-sm animate-pulse">
            {/* Status bar */}
            <div className="w-full h-1 rounded-full mb-3 bg-gray-300"></div>

            {/* ID and Badge row */}
            <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-2 flex-1">
                    <div className="w-3 h-3 bg-gray-300 rounded"></div>
                    <div className="h-4 bg-gray-300 rounded w-24"></div>
                </div>
                <div className="h-6 bg-gray-200 rounded-full w-16"></div>
            </div>

            {/* Customer name */}
            <div className="flex items-center gap-2 mb-3">
                <div className="w-3 h-3 bg-gray-300 rounded"></div>
                <div className="h-4 bg-gray-300 rounded flex-1"></div>
            </div>

            {/* Job type badge */}
            <div className="mb-3">
                <div className="h-6 bg-gray-200 rounded-full w-28"></div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                <div className="flex items-center gap-1">
                    <div className="w-3 h-3 bg-gray-300 rounded"></div>
                    <div className="h-3 bg-gray-300 rounded w-20"></div>
                </div>
                <div className="h-3 bg-gray-300 rounded w-24"></div>
            </div>
        </div>
    );
};

export const DayColumnSkeleton = ({ dayLabel, dayDate }) => {
    return (
        <div className="bg-gray-50 border-2 border-gray-200 rounded-xl overflow-hidden min-h-[300px]">
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-3 py-2 border-b border-gray-200">
                <div className="text-center">
                    <h3 className="font-bold text-gray-900 text-sm">{dayLabel}</h3>
                    <p className="text-xs text-gray-500">{dayDate}</p>
                </div>
            </div>
            <div className="p-2 space-y-2">
                <AssignmentCardSkeleton />
                <AssignmentCardSkeleton />
            </div>
        </div>
    );
};

export const UnscheduledSectionSkeleton = () => {
    return (
        <div className="bg-white border-2 border-dashed border-gray-300 rounded-xl p-6">
            <div className="flex items-center justify-between mb-4">
                <div className="h-6 bg-gray-300 rounded w-48 animate-pulse"></div>
                <div className="h-8 bg-gray-200 rounded-full w-32 animate-pulse"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                <AssignmentCardSkeleton />
                <AssignmentCardSkeleton />
                <AssignmentCardSkeleton />
                <AssignmentCardSkeleton />
            </div>
        </div>
    );
};
